/* eslint-disable no-underscore-dangle */
import merge from 'lodash/merge';

type Sidecar = {
  __sidecarFormatVersion: number;
  applicationId: string;
  applicationName: string;
  appsApiBaseUrl: string;
  cdfApiBaseUrl: string;
  docsSiteBaseUrl: string;
  nomaApiBaseUrl: string;
  aadApplicationId: string;
};

let cdfApiUrl = `https://az-arn-001.cognitedata.com`;

if (
  process.env.REACT_APP_ENV === 'mock' ||
  process.env.REACT_APP_ENV === 'testcafe'
) {
  cdfApiUrl = 'http://localhost:11111';
}

const sidecar = merge(
  {},
  {
    __sidecarFormatVersion: 1,
    applicationId: 'isolation-planning',
    applicationName: 'Isolation Planning',
    appsApiBaseUrl: 'https://apps-api.omv.cognite.ai',
    privacyPolicyUrl: 'https://www.cognite.com/en/policy',
    cdfApiBaseUrl: cdfApiUrl,
    disableLegacyLogin: true,
    enableUserManagement: false,
    docsSiteBaseUrl: 'https://docs.cognite.com',
    cdfCluster: 'az-arn-001',
    disableUrlClusterInjection: true,
  },
  /* eslint-disable @typescript-eslint/no-explicit-any */
  // eslint-disable-next-line no-underscore-dangle
  (window as any).__cogniteSidecar
) as Sidecar;

export default sidecar;
